import Button from "@edaz/edazkit/Button";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import type { ViewComponent } from "@frui.ts/views";
import { View, registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";
import PrevNextNavigationHeader from "../../../../common/prevNextNavigationHeader";
import OrderSection from "../../common/orderSection";
import OriginalPayGatePaymentSection from "../../common/originalPayGatePaymentSection";
import OriginalTransferPaymentSection from "../../common/originalTransferPaymentSection";
import RefundSection from "./refundSection";
import RejectionDetailSection from "./rejectionDetailSection";
import CustomerRefundType from "entities/customerRefundType";
import FuelTypeSection from "../../common/fuelTypeSection";

export const RejectedCustomerRefundCandidateDetailView: ViewComponent<RejectedCustomerRefundCandidateDetailViewModel> = observer(
  ({ vm }) => {
    return (
      <Modal scrollable show={true} centered={true} onHide={vm.requestClose} dialogClassName="modal-90w">
        <Modal.Header closeButton={true}>
          <PrevNextNavigationHeader vm={vm} />
          <ButtonToolbar className="flex-grow-1 justify-content-end">
            {vm.item?.permittedActions.recreation.isAllowed && vm.allowToRecreate && (
              <Button onClick={vm.onRecreateClick} variant="primary" disabled={vm.busyWatcher.isBusy} className="text-uppercase">
                {vm.translate("recreate")}
              </Button>
            )}
          </ButtonToolbar>
        </Modal.Header>
        <Modal.Body>
          <View vm={vm.alertsViewModel} useLifecycle={true} />
          {vm.item ? (
            <LoaderOverlay loading={vm.busyWatcher.isBusy}>
              <Row className="mb-4">
                <Col>
                  <OrderSection vm={vm} />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  {vm.item.originalPayGatePayment || vm.isPayGateRefund ? (
                    <OriginalPayGatePaymentSection vm={vm} />
                  ) : (
                    <OriginalTransferPaymentSection vm={vm} />
                  )}
                </Col>
                <Col md={6}>
                  {vm.item.requestedPriceListItemId && vm.item.refundType === CustomerRefundType.CustomerPartial && (
                    <FuelTypeSection vm={vm} />
                  )}
                  <RefundSection vm={vm} />
                  <RejectionDetailSection vm={vm} />
                </Col>
              </Row>
            </LoaderOverlay>
          ) : (
            <LoaderOverlay loading={true} style={{ minHeight: 200 }} />
          )}
        </Modal.Body>
      </Modal>
    );
  }
);

registerView(RejectedCustomerRefundCandidateDetailView, RejectedCustomerRefundCandidateDetailViewModel);
